import { render, staticRenderFns } from "./ModalBarang.vue?vue&type=template&id=490a4174&scoped=true"
import script from "./ModalBarang.vue?vue&type=script&lang=js"
export * from "./ModalBarang.vue?vue&type=script&lang=js"
import style0 from "./ModalBarang.vue?vue&type=style&index=0&id=490a4174&prod&lang=scss"
import style1 from "./ModalBarang.vue?vue&type=style&index=1&id=490a4174&prod&lang=scss&scoped=true"
import style2 from "./ModalBarang.vue?vue&type=style&index=2&id=490a4174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a4174",
  null
  
)

export default component.exports